// Module
var code = "<div> <div class=\"name\">Decision Letter</div> <template v-if=\"editing == true\"> <dropdown-field :null-is-dirty=\"true\" label=\"Decision Letter\" :value.sync=\"filter.hasDecisionLetter\" :options=\"decisionLetterOptions\"></dropdown-field> </template> <template v-if=\"editing == false\">{{ selectedLabel }}</template> </div> ";
// Exports
export default code;